import(/* webpackMode: "eager" */ "/usr/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["AppName"] */ "/usr/app/webapps/tenant/src/components/app-name.tsx");
